// import Endpoints from './api';
import { makeSerial, GUID, replaceAll } from 'core/utils';
import Track from 'src/paraphraser/handlers/track';
// import WaltCache from './walt_cache';
import ParaModel from 'src/paraphraser/handlers/ParaModel';
// import us2uk from 'public/jsonData/us2uk';
import { QUILL_SETTINGS } from '../constants';
import { APP_SETTINGS } from 'config/constants';
import { getTimeDifference } from 'src/_common/handlers/helper';

const loadingColor = 'rgb(234, 156, 19)';

function handleExceptions(seg) {
  if (seg.text === '/') {
    seg.pos = 'slash';
    seg.depPhrase = '/|slash';
    seg.phrase = '/';
  }

  if (seg.text === '"') {
    seg.pos = 'quote';
    seg.depPhrase = '"|quote';
    seg.phrase = '"';
  }
}

class Segment {
  constructor(segData, output, index, cb) {
    if (segData === null) return;
    this.segModelId = segData.segmentorModelId;
    this.printFiltered = false;
    this.segData = segData;
    this.walts = output.walts;
    this.pre = segData.pre ? segData.pre : '';
    this.post = segData.punct ? segData.punct : '';
    this.setText(segData.text);
    this.phrase = segData.text;
    this.origText = segData.origText ? this.formatContractions(segData.origText) : this.text;
    this.key = segData.key;
    if (this.key) this.key = this.key.toLowerCase();
    this.isUpperCased = this.segData.text && segData.text[0] === segData.text[0].toUpperCase();
    this.usedWalt = false;
    this.autoflipped = false;
    //console.log(this.key)
    this.loading = segData.loading;

    this.color = 'black';
    this.prompt = false;
    this.segID = GUID();
    this.output = output;
    this.hidden = false;
    this.index = index - 1;
    this.waltedText = '';
    this.thinkingTime = 0;
    this.thinkingTimeStart = 0;
    // this.thinkingTimer = null;
    this.pos = segData.ptag;
    this.isDiff = false;
    this.depPhrase = segData.dep_phrase;
    this.shownFiller = false;
    this.shownAlts = false;
    this.altsShown = 6;
    this.flipperModelId = output?.flipperModelId;
    //console.log(segData)

    if (this.depPhrase === undefined) {
      this.depPhrase = this.text
        .split(' ')
        .map(x => x + '|*')
        .join('_');
    }

    var str = this.output && this.output.fthresh ? this.output.fthresh : QUILL_SETTINGS.fthresh;
    // var wkey = str + '~' + output.initText;
    //console.log(wkey)
    // Don't remove. Will need this when Synonyms upgrade.
    this.flips = output.flips;
    // this.flips = WaltCache.flips[wkey];
    if (this.flips) {
      this.flips.forEach(w => {
        try {
          if (w[0] === this.key) {
            // var oText = segData.origText ? segData.origText : this.text;
            var repText = w[1];
            // Commented out for bypassing the application of auto-flips
            // if (this.isUpperCased) {
            //   repText = repText[0].toUpperCase() + repText.slice(1);
            // }
            if (this.text?.toLowerCase() === repText?.toLowerCase()) {
              this.autoflipped = true;
              // this.origText = oText;
              this.waltedText = repText;
              // this.setText(repText);
              setTimeout(() => {
                this.anFix(index);
              }, 50);
            }
          }
        } catch (e) {
          console.log('WHO TOUCHA');
        }
      });
    }

    this.setAlts(segData.alts);
    this.setFillers(segData.fillers);

    this.init();
    var forcedPrevSpaces = ['('];
    var forcedNoPostSpace = ['(', '-', '$', '#', '~', 'ca'];
    var hyphens = ['-', '–'];
    this.forcePrevSpace = forcedPrevSpaces.includes(this.text);
    this.forceNoPostSpace =
      forcedNoPostSpace.includes(this.text) ||
      (this.text.length > 0 && hyphens.includes(this.text[this.text.length - 1]));
    if (cb !== undefined) {
      cb(this);
    }

    handleExceptions(this);
  }

  makeRegional(text) {
    if (APP_SETTINGS.REGION === 'uk') {
      text = text
        .split(' ')
        .map(w => {
          if (ParaModel.us2ukData && ParaModel.us2ukData[w]) {
            return ParaModel.us2ukData[w];
          }
          return w;
        })
        .join(' ');
    } else if (APP_SETTINGS.REGION === 'au') {
      text = text
        .split(' ')
        .map(w => {
          if (ParaModel.us2auData && ParaModel.us2auData[w]) {
            return ParaModel.us2auData[w];
          }
          return w;
        })
        .join(' ');
    }
    return text;
  }

  setText(text) {
    this.text = this.formatContractions(text);
  }

  formatContractions(text) {
    text = this.makeRegional(text);
    text = text.replace(/_/g, ' ');
    text = text.replace(/\s're/g, "'re");
    text = text.replace(/\s've/g, "'ve");
    text = text.replace(/\sn't/g, "n't");
    text = text.replace(/\si\s/g, ' I ');
    text = text.replace(/\snt/g, 'nt');
    //text = text.replace(/wanna/g, "want to")
    //text = text.replace(/gonna/g, "going to")
    text = text.replace(/\s's/g, "'s");
    text = text.replace(/\s'll/g, "'ll");
    text = text.replace(/\s'm/g, "'m");
    text = text.replace(/\s'd/g, "'d");
    while (
      text.includes('//') &&
      !text.toLowerCase().includes('http') &&
      !text.toLowerCase().includes('https')
    ) {
      text = replaceAll(text, '//', '/');
    }
    while (text.includes('--')) {
      text = replaceAll(text, '--', '—');
    }

    if (text === 'i') return 'I';
    //if(this.segData.punct){
    if (this.segData.pre) {
      text = this.segData.pre + text;
    }
    if (this.segData.punct) {
      text += this.segData.punct;
    }

    //}
    return text;
  }

  init() {
    this.onclick = this.openPrompt.bind(this);
    this.checkIfDiff();
  }

  loadExport(seg, output) {
    // this.output = output;
    var self_serializable = ['output'];
    Object.keys(seg).forEach(prop => {
      if (self_serializable.includes(prop)) return;
      this[prop] = seg[prop];
    });

    // this.init();
  }

  serialize() {
    return makeSerial(this, ['output']);
  }

  breakPhrase(cb) {
    this.output.fixBreaks(this.phrase);
    this.output.outputChanged({ action: 'breakPhrase', text: this.phrase });
    // if (cb) cb();
  }

  checkIfDiff() {
    if (!this.output.paraphraser.origText.includes(this.text)) {
      this.changeColor('#E36B00');
      this.isDiff = true;
    }
  }

  preToggle() {
    this.selectAlt(this.alts[1]);
  }

  /* deleteSelf() {
    Track.deleteSeg(this.output.outID, this.origText, this.text);
    this.output.segs.splice(this.output.segs.indexOf(this), 1);
  } */

  openPrompt(cb) {
    this.output.clearSegPrompts();
    this.prompt = true;
    this.getAltDefs(8);
    Track.segmentClicked(
      this.origText,
      this.text,
      this.output.outID,
      ParaModel.inputLanguage,
      ParaModel.submissionID
    );
    // this.thinkingTimer = setInterval(() => {
    //   this.thinkingTime += 0.1;
    // }, 100);
    this.thinkingTimeStart = Date.now();
    if (cb) cb();
  }

  closePrompt() {
    this.prompt = false;
    // clearInterval(this.thinkingTimer);
    // this.thinkingTimer = null;
    this.thinkingTime += getTimeDifference(this.thinkingTimeStart);
    this.thinkingTimeStart = 0;
  }

  getAlts() {
    //TODO
  }

  setAlts(alts) {
    //console.log("setting alts")
    if (alts === undefined) {
      this.alts = [];
    } else {
      this.alts = alts.map(alt => {
        alt['phrase'] = alt.text
          .split('_')
          .map(p => {
            return p.split('|')[0];
          })
          .join('_');
        alt['displayText'] = this.formatContractions(alt['phrase']);
        return alt;
      });
    }

    if (this.segData.flippedWordsWithinSeg) {
      var words = this.segData.text.split(' ');
      // let alted = this.segData.flippedWordWithinSeg.alted;
      // let orig = this.segData.flippedWordWithinSeg.orig;
      let waltedSeg = null;
      if (words.length > 1) {
        let new_words = words.map((w, ind) => {
          let internalKey = w + '~~' + ind;
          let orig = this.segData.flippedWordsWithinSeg[internalKey];
          if (orig) {
            return orig;
          } else {
            return w;
          }
        });
        waltedSeg = new_words.join(' ');
      }
      if (waltedSeg) {
        waltedSeg = this.formatContractions(waltedSeg);
        if (waltedSeg !== this.text) {
          this.waltedText = waltedSeg;
          this.usedWalt = true;
          this.origText = waltedSeg;
          this.alts.unshift({
            phrase: waltedSeg,
            displayText: waltedSeg,
            text: waltedSeg + '|root',
          });
        }
      }
    }

    if (this.walts && this.key && this.walts[this.key] !== undefined) {
      this.usedWalt = true;
      // var bad = 0

      var old_alts = this.alts;
      var walts = this.walts[this.key];
      var a_disps = [];
      var new_alts = [];
      walts.forEach(w => {
        //console.log(this.isUpperCased, this.text)
        if (this.isUpperCased && w.length > 0) {
          w = w[0].toUpperCase() + w.slice(1);
        }

        if (w === this.segData.text) return;

        if (!this.pre) this.pre = '';
        if (!this.post) this.post = '';
        var dword = this.pre + w + this.post;
        if (a_disps.indexOf(dword) === -1) {
          a_disps.push(dword);
          new_alts.push({
            phrase: dword,
            displayText: dword,
            text: w + '|root',
            source: 'single-flip',
          });
        }
      });

      this.alts = new_alts;
      old_alts.forEach(a => {
        if (a_disps.indexOf(a['displayText']) === -1) {
          this.alts.push(a);
        }
      });

      //console.log(this.text, this.origText)
      if (this.text !== this.origText) {
        this.alts.unshift({
          phrase: this.origText,
          displayText: this.origText,
          text: this.origText + '|root',
        });
      }
    }
    let filteredAlts = [];
    this.alts.forEach((alt, ind) => {
      if (alt.displayText === this.origText && ind !== 0) {
        return;
      } else {
        filteredAlts.push(alt);
      }
    });
    this.alts = filteredAlts;
  }

  setFillers(fillers) {
    if (fillers === undefined) {
      this.fillers = [];
    } else {
      this.fillers = fillers.map(filler => {
        filler['phrase'] = filler.text
          .split('_')
          .map(p => {
            return p.split('|')[0];
          })
          .join('_');
        filler['displayText'] = this.formatContractions(filler['phrase']);
        return filler;
      });
    }
  }

  getAltDefs(topn) {
    if (ParaModel.wordExtension) {
      this.alts.forEach(a => {
        a.definitions = 'N/A';
      });
    }
    return;
    // this.alts.slice(0, topn).forEach(alt=>{
    //   if(alt.definitions === undefined){
    //     var text = this.formatContractions(alt.phrase)
    //     if(text.includes(" ")){
    //       alt.definitions = "N/A"
    //     }else{
    //       Endpoints.getDefinition({phrase: text}, (def)=>{
    //         let defs = def.defs?def.defs: "N/A";
    //         alt.definitions = defs
    //       }, ()=>{
    //         alt.definitions = "N/A"
    //       })
    //     }
    //   }
    // })
  }

  fixSplit(rightHalf) {
    this.text = this.text + rightHalf;
    this.origText = this.origText + rightHalf;
    this.alts = [];
  }

  anFix() {
    try {
      var vowels = ['a', 'e', 'i', 'o', 'u'];
      var my_idx = this.output.segs.indexOf(this);
      // if(my_idx === -1 && this.output.segs.length > 0){
      //   my_idx = this.output.segs.length
      // }
      //console.log("checking anFixes", my_idx)

      if (my_idx >= 1) {
        var last_seg = this.output.segs[my_idx - 1];
        var last_word = last_seg.text.split(' ').slice(-1)[0];
        var is_vowel = vowels.indexOf(this.text[0].toLowerCase()) !== -1;
        if (is_vowel && last_word === 'a') {
          last_seg.text = last_seg.text.split(' ').slice(0, -1).concat('an').join(' ');
        } else if (!is_vowel && last_word === 'an') {
          last_seg.text = last_seg.text.split(' ').slice(0, -1).concat('a').join(' ');
        }
        //console.log(this.text, my_idx, is_vowel, last_word, last_seg.text)
      }
    } catch (e) {
      console.log('crashed on the a/an fix');
    }
  }

  selectAlt(alt, cb, dontSaveHist) {
    this.thinkingTime += getTimeDifference(this.thinkingTimeStart);
    this.thinkingTimeStart = 0;
    var newText = replaceAll(alt.displayText, '_', ' ');
    var context = this.output.getOutputString();
    const fthresh = this.output.fthresh;
    this.output.thesaurusedCount++;
    if (this.origText === newText) this.output.waltedCount++;
    Track.thesaurused(
      this.origText,
      this.text,
      newText,
      this.output.outID,
      'alt',
      this.usedWalt,
      this.waltedText,
      this.thinkingTime,
      this,
      context,
      fthresh,
      this.flipperModelId,
      ParaModel.inputLanguage,
      this.segModelId,
      this.alts.indexOf(alt) + 1,
      alt.source ? alt.source : 'segmenter-response'
    );
    if (this.alts !== null) {
      this.alts.splice(this.alts.indexOf(alt), 1);
      var firstAlt = {
        text: this.depPhrase,
        phrase: this.text,
        displayText: this.text,
        similarity: 0,
      };
      this.alts.unshift(firstAlt);
      this.text = newText;

      // a an fix
      this.anFix();

      this.depPhrase = alt.text;
      this.checkIfDiff();
      if (!dontSaveHist) {
        this.output.saveHistory('thes', this, firstAlt, 'alt');
      }

      this.output.outputChanged({
        action: 'thesaurus',
        origText: this.origText,
        newText: newText,
        waltedText: this.waltedText,
        thinkingTime: this.thinkingTime,
        filler: false,
      });
      setTimeout(() => {
        this.output.clearSegPrompts();
        if (cb) cb();
      }, 20);
    }
  }

  selectFiller(filler, cb, dontSaveHist) {
    this.thinkingTime += getTimeDifference(this.thinkingTimeStart);
    this.thinkingTimeStart = 0;
    var context = this.output.getOutputString();
    var newText = replaceAll(filler.displayText, '_', ' ');
    const fthresh = this.output.fthresh;
    if (this.origText === newText) this.output.waltedCount++;
    Track.thesaurused(
      this.origText,
      this.text,
      newText,
      this.output.outID,
      'filler',
      this.usedWalt,
      this.waltedText,
      this.thinkingTime,
      this,
      context,
      fthresh,
      this.flipperModelId,
      ParaModel.inputLanguage,
      this.segModelId,
      this.fillers.indexOf(filler) + 1,
      'segmenter-response'
    );
    if (this.fillers !== null) {
      this.fillers.splice(this.fillers.indexOf(filler), 1);
      var firstAlt = {
        text: this.depPhrase,
        phrase: this.text,
        displayText: this.text,
        similarity: 0,
      };
      this.fillers.unshift(firstAlt);
      this.text = newText;
      this.depPhrase = filler.text;
      this.checkIfDiff();
      if (!dontSaveHist) {
        this.output.saveHistory('thes', this, firstAlt, 'filler');
      }
      this.output.outputChanged({
        action: 'thesaurus',
        origText: this.origText,
        newText: newText,
        waltedText: this.waltedText,
        thinkingTime: this.thinkingTime,
        filler: true,
      });
      setTimeout(() => {
        this.output.clearSegPrompts();
        if (cb) cb();
      }, 20);
    }
  }

  changeColor(color, cb) {
    if (this.loading) color = loadingColor;
    this.color = color;
    if (cb) cb();
  }

  makeRed(e, cb) {
    if (this.alts.length === 0) return;
    if (e) e.stopPropagation();
    this.changeColor('#9B51E0', cb);
  }

  makeBlue(e, cb) {
    this.changeColor('blue', cb);
  }

  makeBlack(e, cb) {
    if (e) e.stopPropagation();
    this.changeColor('#252525', cb);
    this.checkIfDiff();
  }
}

export default Segment;
